import * as React from 'react';
var TriggerContext = /*#__PURE__*/React.createContext(null);
export default TriggerContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-select/node_modules/rc-trigger/es/context.js
// module id = 1295
// module chunks = 0